import { useContext } from 'react';
import { NotificationsContext } from '../contexts/notificationContext';

export default function useNotifications() {
    return useContext(NotificationsContext);
}
